// frontend/src/pages/PaymentHistory/components/InfoBanner.tsx
// Amber info banner. Used at the top of the Payment History page to call out
// that recorded payments do not yet confirm bank settlement.
// Content is passed via children; a bold prefix can be set with the `strong` prop.

import React from "react";
import { Info } from "lucide-react";
import { T } from "../styles";

interface InfoBannerProps {
  /** Optional bold leading sentence. */
  strong?: string;
  /** Body text or any other React content. */
  children: React.ReactNode;
}

export default function InfoBanner({
  strong,
  children,
}: InfoBannerProps): React.ReactElement {
  return (
    <div
      style={{
        background: T.amberTint,
        border: "1px solid " + T.amberBorder,
        color: T.amberInk,
        padding: "12px 16px",
        borderRadius: 8,
        marginBottom: 24,
        fontSize: 13,
        fontWeight: 500,
        lineHeight: 1.5,
        display: "flex",
        alignItems: "flex-start",
        gap: 10,
      }}
    >
      <Info size={16} style={{ flexShrink: 0, marginTop: 1 }} />
      <span>
        {strong && (
          <>
            <b style={{ color: T.amberDeep, fontWeight: 700 }}>{strong}</b>{" "}
          </>
        )}
        {children}
      </span>
    </div>
  );
}